import { gql } from "lib/apolloClient";
import { workbookTemplateFragment } from "./WorkbookTemplateFragmentsV2";

export const getWorkbookTemplateQuery = gql`
  query getWorkbookTemplates(
    $organizationId: ID!
    $types: [ORGANIZATION_RESOURCE_TYPE_ENUM!]
    $searchText: String!
    $first: Int
    $after: String
    $states: [ORGANIZATION_RESOURCE_STATE_ENUM!]
    $status: ORGANIZATION_RESOURCE_STATUS_ENUM
    $courseIds: [ID!]
    $createdBy: [ID!]
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        workbookTemplatesV2(types: $types, filters: { states: $states }) {
          workbookTemplateResource {
            ...workbookTemplateResourceBasicDetailsItem
          }
        }
      }
    }
  }

  ${workbookTemplateFragment.workbookTemplateResourceBasicDetailsItem}
  ${workbookTemplateFragment.attachmentFragment}
`;

export const getWorkbookTemplateFolderQueryV2 = gql`
  query getWorkbookTemplateFolderV2(
    $id: ID!
    $types: ENTITY_TYPE_ENUM!
    $searchText: String
    $first: Int
    $after: String
    $states: [ORGANIZATION_RESOURCE_STATE_ENUM!]
  ) {
    node(id: $id, type: $types) {
      id
      ... on WorkbookTemplateResource {
        childrenV2(
          first: $first
          after: $after
          filters: { searchText: $searchText, states: $states }
        ) {
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
          edges {
            node {
              ... on WorkbookTemplateResource {
                id
                label
                type
                resourceType
                state
                attachment {
                  ...attachmentFragment
                }
                createdBy {
                  id
                  firstName
                  middleName
                  lastName
                }
              }
            }
          }
        }
      }
    }
  }
  ${workbookTemplateFragment.attachmentFragment}
`;

export const getWorkbookSchoolTemplateQueryV2 = gql`
  query getWorkbookSchoolTemplateQueryV2(
    $types: [ORGANIZATION_RESOURCE_TYPE_ENUM!]
    $organizationId: ID!
    $curriculumProgramId: ID!
    $searchText: String!
    $first: Int
    $after: String
    $status: ORGANIZATION_RESOURCE_STATUS_ENUM
    $states: [ORGANIZATION_RESOURCE_STATE_ENUM!]
    $courseIds: [ID!]
    $createdBy: [ID!]
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        workbookTemplatesV2(curriculumProgramId: $curriculumProgramId) {
          isSuccess
          warning
          workbookTemplateResource {
            ...workbookTemplateResourceBasicDetailsItem
          }
        }
      }
    }
  }

  ${workbookTemplateFragment.workbookTemplateResourceBasicDetailsItem}
  ${workbookTemplateFragment.attachmentFragment}
`;

export const getWorkbookSchoolTemplatesCountQueryV2 = gql`
  query getWorkbookSchoolTemplatesCountQueryV2(
    $types: [ORGANIZATION_RESOURCE_TYPE_ENUM!]
    $organizationId: ID!
    $curriculumProgramId: ID!
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        workbookTemplatesV2(curriculumProgramId: $curriculumProgramId) {
          isSuccess
          warning
          workbookTemplateResource {
            id
            childrenV2(filters: { types: $types }) {
              resourceTypeBasedCount {
                totalCount
              }
            }
          }
        }
      }
    }
  }
`;
